<template>
  <v-theme-provider :dark="dark">
    <div>
      <base-info-card
        :title="title"
        color="primary"
      >
        <slot />
      </base-info-card>

      <template v-for="(contact, i) in contacts">
        <base-avatar-card
          :key="i"
          :icon="contact.fields.icon"
          :outlined="false"
          :title="!dense ? contact.fields.title : undefined"
          color="transparent"
          horizontal
          space="0"
          size="47"
        >
          <!-- Do not use v-html for user -->
          <!-- provided values -->
          <div v-html="contact.fields.text" />
        </base-avatar-card>

        <v-divider
          v-if="i + 1 !== contacts.length"
          :key="`divider-${i}`"
          class="my-2"
        />
      </template>
    </div>
  </v-theme-provider>
</template>

<script>
  export default {
    name: 'BaseBusinessContact',

    props: {
      dark: Boolean,
      dense: Boolean,
      title: String,
      contacts: Array,
    },
  }
</script>
